<template >
  <div class="col-12 col-lg-10" :class="[defaultSite.isStudent, 'container-fluid bg-light p-3']">
    <div class="row justify-content-between">
        <div class="col-12 col-lg-4 p-3 align-items-center justify-content-between d-flex">
          <img v-if="defaultSite.isStudent" height="100" src="https://cdn.trailfinders.com/backpackers__insurance.svg" />
          <img v-else width="300" src="https://cdn.trailfinders.com/travel_insurance_logo.svg"/>
        </div>
         
        <div class="col-12 col-md-7 p-3 row align-items-center">

    <!-- TrustBox widget - Micro Combo -->
     <div id="trustpilot-container" class="col-12 col-lg-6 mb-3">
        <!-- //the trustbox gets inserted by script to ensure loads after dom created. see handlebars page in express -->
        <div class="trustpilot-widget col" 
                data-locale="en-GB" 
                data-template-id="5419b6ffb0d04a076446a9af" 
                data-businessunit-id="4a52202d0000640005045750" 
                data-style-height="20px" 
                data-style-width="100%"> 
            <a href="https://uk.trustpilot.com/review/www.trailfinders.com" 
                target="_blank" 
                rel="noopener">Trustpilot
            </a>
          </div>
     </div>
    
    <!-- End TrustBox widget -->
          <p class="tf-vue-title-text fw-bold text-end col mb-0" :class="[defaultSite.isStudent, 'text-dark text-shadow']">
            Trailfinders Insurance Hotline:
            <strong>{{defaultSite.telephone}}</strong> |
            <a class="text-decoration-none fw-bold" href="/privacy" target="_blank" >Privacy Policy</a> 
            <!-- <a class="help text-decoration-none fw-bold">
              <span class="glyphicon glyphicon-question-sign"></span>
              <help-modal :defaultSite='defaultSite'></help-modal>
            </a> -->
          </p>
        </div>
      </div>

      <ul class="tf-vue-progress-tracker p-0">
        <li :class="{ active: step1Active }"><a>1. Get A Quote</a></li>
        <li :class="{ active: step2Active }"><a>2. Select Policy</a></li>
        <li :class="{ active: step3Active }"><a>3. Your Policy</a></li>
        <li :class="{ active: step4Active }"><a>4. You're Covered</a></li>
      </ul>
  </div>
</template>


<script>
export default {
  mounted() {
    var element = document.getElementsByClassName("trustpilot-widget");
      for(var i=0; i<element.length; i++) {
      window.Trustpilot.loadFromElement(element[i]);
    }
  },
  props: [
    'defaultSite', 
    'step1Active', 
    'step2Active', 
    'step3Active', 
    'step4Active'
  ]
}
</script>

<style scoped lang="scss">
@use "../assets/scss/_variables/variables" as vars;
@use "../assets/scss/_mixin/_mixin" as mixin;
.tf-vue-progress-tracker {
  list-style-type: none;
  overflow: hidden;
  margin: 0 0 30px 0;
  
  li {
    float: left;
    width: 25%;
    padding: 0;
    margin: 0;

    a {
      font: {
        weight: 700;
      }
      color: vars.$c-grey-5;
      @include mixin.fontSize(14px);
      text: {
        decoration: none;
        transform: uppercase;
        align: right;
      }
      letter-spacing: 0;
      padding: 20px 0 20px 25px;
      background: vars.$c-grey-1;
      position: relative;
      display: block;
      float: left;
      width: 100%;

      &::after {
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border-top: 34px solid transparent;
        border-bottom: 34px solid transparent;
        border-left: 34px solid vars.$c-grey-1;
        position: absolute;
        top: 50%;
        margin-top: -34px;
        left: 100%;
        z-index: 2;
      }

      &::before {
        content: " ";
        display: block;
        width: 0;
        height: 0;
        border-top: 34px solid transparent;
        border-bottom: 34px solid transparent;
        border-left: 34px solid vars.$c-white-1;
        position: absolute;
        top: 50%;
        margin-top: -34px;
        margin-left: 2px;
        left: 100%;
        z-index: 1;
      }
    }

    &:first-child a {
      padding-left: 20px;
    }

    &.active a {
      color: vars.$c-white-1;
      cursor: default;
      background: vars.$c-blue-1;

      &:after {
        border-left-color: vars.$c-blue-1;
      }
    }

    &.disable a {
      color: vars.$c-grey-3;
      cursor: not-allowed;

      &.done > span {
        padding-left: 10px;
        font: {
          size: vars.$f-size-base*0.75;
          family: 'Glyphicons Halflings';
        }

        &::before{
          content: "\e013";
        }
      }

    }

    &:last-child a {
      padding-right:20px;
      @include mixin.border-radius(0 5px 5px 0);
      @media screen and (min-width: 769px) and (max-width: 992px){
        padding-right: 10px;
      }

      &:after {
        border-left: 0;
      }
    }

  }

  @media screen and (max-width: 767px){
    li {
      width: 100%;
      margin-top: 1px;

      a {
        text: {
          align: center;
        }
        letter-spacing: 1px;
        padding: 15px 0;
        background: vars.$c-grey-1;
        position: relative;
        display: block;
        float: left;
        width: 100%;

        &:after {
          content: " ";
          display: block;
          width: 0;
          height: 0;
          border:0;
          position: absolute;
          top: 0;
          margin-top: 0;
          margin-left: 0;
          left: 0;
          z-index: 2;
        }

        &:before {
          content: " ";
          display: block;
          width: 0;
          height: 0;
          border:0;
          position: absolute;
          top: 0;
          margin-top: 0;
          margin-left: 0;
          left: 0;
          z-index: 1;
        }
      }

      &:first-child a {
        padding-left: 0;
        @include mixin.border-radius(5px 5px 0 0);
      }

      &.active a {
        color: white;
        background: vars.$c-blue-1;

        &:after {
          border-top-color: vars.$c-blue-1;
          border-left-color:  transparent;
        }
      }

      &:last-child a {
        padding-right:0;
        @include mixin.border-radius(0 0 5px 5px);

        &:after{
          border: 0;
        }
      }
    }
  }
}
.tf-vue-title-text {
  font-size: 12px;
}

</style>